var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"title","options":_vm.optionsSelect,"disabled":_vm.disabled},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})}
var staticRenderFns = []

export { render, staticRenderFns }